<div class="start-container">
    <img class="start-img" src="assets/hex/hex-start.png" />
</div>